module.exports = __webpack_public_path__ + "img/Steve Hurst.7d0538ec.jpg";